/** Human-readable sector label from API shapes (string, id, or { id, name }). */
export function getSectorDisplayName(sector, formSchemaSector) {
  if (!sector && !formSchemaSector) return "";
  if (typeof sector === "string") return sector;
  if (typeof sector === "object" && sector !== null) {
    return sector.name || formSchemaSector || "";
  }
  return formSchemaSector || "";
}
